import { ReactComponent as Logo } from 'img/jll-logo.svg';
import styles from './headerLogo.module.scss';
import PdfIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useState, useMemo } from 'react';
import { ReactComponent as ShareIcon } from 'icons/share.svg';
import { ReactComponent as CopyIcon } from 'icons/copy.svg';
import { Button, CircularProgress } from '@mui/material';
import actions from 'store/actions';
import paths from 'constants/paths';
import { getFullPathOrHome } from 'utils/paths';

export default function HeaderLogo(props) {
  const {
    enableButtons = false,
    isReadOnlyMode = false,
    showCopyDialog,
    showDrawer,
    getPdfReport,
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const externalAccessConfig = useSelector((state) => state.externalAccessConfig);
  const isExternalAccess = useSelector((state) => state.general.isExternalAccessMode);
  const { t } = useTranslation();

  const handleDownload = async () => {
    setLoading(true);
    await getPdfReport();
    setLoading(false);
  };

  const isExternalAccessAndAllModesEnabled = useMemo(
    () =>
      isExternalAccess &&
      externalAccessConfig.readModeEnabled &&
      externalAccessConfig.interactiveModeEnabled,
    [isExternalAccess, externalAccessConfig],
  );

  const handleClick = () => {
    if (isExternalAccessAndAllModesEnabled) {
      dispatch(actions.na.resetNA());
      history.push(getFullPathOrHome(`${paths.externalAccess}${location.search}`));
    }
  };

  return (
    <div className={styles.container}>
      <div
        className={styles.logo_container}
        onClick={handleClick}
        style={{ cursor: isExternalAccessAndAllModesEnabled ? 'pointer' : 'initial' }}>
        <Logo role="jll-logo" className={styles.logo}></Logo>
        <div className={styles.verticalLine}></div>
        <div>Needs Assessment</div>
      </div>
      {enableButtons && (
        <div className={styles.assessment__actions}>
          {!isExternalAccess && !isReadOnlyMode ? (
            <Button
              data-testid="Step6CopyAssessmentButton"
              onClick={() => showCopyDialog(true)}
              className={styles.assessment__copy}
              size="small"
              variant="contained"
              startIcon={<CopyIcon />}>
              {t('library.copyBtn')}
            </Button>
          ) : null}

          {!isExternalAccess && !isReadOnlyMode ? (
            <Button
              data-testid="Step6ShareAssessmentButton"
              onClick={() => showDrawer(true)}
              className={styles.assessment__share}
              size="small"
              variant="contained"
              startIcon={<ShareIcon />}>
              {t('step6.shareButton')}
            </Button>
          ) : null}

          <Button
            data-testid="Step6PdfReportButton"
            className={styles.assessment__pdf}
            size="small"
            variant="contained"
            startIcon={loading ? <CircularProgress size={16} color={'primary'} /> : <PdfIcon />}
            disabled={loading}
            onClick={handleDownload}>
            {t('step6.download')}
          </Button>
        </div>
      )}
    </div>
  );
}
